<div class="tw-flex tw-flex-col tw-bg-white tw-h-full font-noto">
  <loading class="tw-flex-1 tw-justify-self-center tw-self-center" *ngIf="loading"></loading>
  @if (fromReviewOrderPage && !loading) {
    <div class="tw-grid tw-grid-cols-[40px_1fr_40px] tw-w-full tw-h-18 tw-px-6 tw-bg-black tw-z-[100] tw-items-center tw-flex-shrink-0">
      <div class="tw-h-10 tw-w-10 tw-flex tw-items-center tw-justify-center tw-rounded-xl" (click)="back()">
        <cs-icon class="tw-h-6 tw-w-6 tw-text-gray-50" [iconName]="'arrow_back'"></cs-icon>
      </div>
      @if (isEdit) {
        <span class="tw-text-300 tw-text-white tw-font-lexend tw-font-normal tw-justify-self-center" i18n="@@yourDeliveryAddress">Edit your address</span>
      } @else {
        <span class="tw-text-300 tw-text-white tw-font-lexend tw-font-normal tw-justify-self-center" i18n="@@addAddress">Add your delivery address</span>
      }
    </div>
  } @else {
    <div class="tw-fixed tw-left-6 tw-top-6 tw-z-10 tw-flex tw-items-center tw-justify-center tw-bg-black tw-rounded-xl tw-h-10 tw-w-10" (click)="back()">
      <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'arrow_back'"></cs-icon>
    </div>
  }
  <!--  Main scrollable container-->

  <div  *ngIf="!loading" class="tw-flex-1 tw-overflow-y-auto" [class]="fromReviewOrderPage ? 'tw-pt-5' : 'tw-pt-24'"
        [ngClass]="{ 'tw-px-[21px]': prefillAddressShiprocketExperiment || acqRebranding2025, 'tw-px-6': !prefillAddressShiprocketExperiment || !acqRebranding2025 }">
    <!--    Main title of the page -->
    @if (!fromReviewOrderPage) {
      <div [ngClass]="{ 'tw-mb-[9px]': prefillAddressShiprocketExperiment || acqRebranding2025 }">
        <div *ngIf="!isEdit" class="tw-font-bold tw-text-black tw-text-600" [class]="prefillAddressShiprocketExperiment || acqRebranding2025 ? 'tw-font-lexend tw-font-[700] tw-pl-1 tw-text-400' : 'tw-font-body'" i18n="@@addAddress">Add your delivery address</div>
        <div *ngIf="isEdit" class="tw-font-bold tw-text-black tw-text-600" [class]="prefillAddressShiprocketExperiment || acqRebranding2025 ? 'tw-font-lexend tw-font-[700] tw-pl-1 tw-text-400' : 'tw-font-body tw-text-600'" i18n="@@yourDeliveryAddress">Edit your address</div>
      </div>
    }
    <!--    subtitle -->
    @if (showAddressDisclaimer) {
      <div class="tw-text-200 tw-text-gray-400 tw-mb-4" [class]="{'tw-mb-0.5': acqRebranding2025}" i18n="@@addressDisclaimer">Complete address help you get your order faster</div>
    }
    <address-form
      #form=""
      [(data)]="addressForm"
      [acqRebranding2025]="acqRebranding2025"
      [prefillAddressShiprocketExperiment]="prefillAddressShiprocketExperiment"
      [shiprocketAddressExists]="shiprocketAddressExists"
      [shiprocketAddressesCount]="shiprocketAddressesCount"
      [shiprocketSticky]="shiprocketSticky"
      [locationLoading]="isLocatingAddress"
      [fromReviewOrderPage]="fromReviewOrderPage"
      (updateLocationInfo)="getLocationDetails()"
    >
      <!-- Shiprocket Banner when sticky is false (projected into address-form) -->
      <shiprocket-address-banner
        *ngIf="shouldShowShiprocketBannerNonSticky"
        #shiprocketBannerNonSticky
        shiprocketCta
        [shiprocketAddressesCount]="shiprocketAddressesCount"
        (findMyAddress)="openShiprocketAddressBottomsheet()"
        (selectAddress)="selectShiprocketAddress()"
      ></shiprocket-address-banner>
    </address-form>
  </div>

  <!--  Shiprocket address Banner - Sticky position (when sticky is true) -->
  <div
    *ngIf="shouldShowShiprocketBannerSticky && !loading"
    class="tw-px-[21px] tw-py-4 tw-transition-all tw-duration-200 tw-ease-in-out"
    [ngClass]="{
      'tw-invisible tw-h-0 tw-overflow-hidden': isKeyboardVisible,
      'tw-visible tw-h-auto': !isKeyboardVisible
    }">
    <shiprocket-address-banner
      #shiprocketBannerSticky
      [shiprocketAddressesCount]="shiprocketAddressesCount"
      (findMyAddress)="openShiprocketAddressBottomsheet()"
      (selectAddress)="selectShiprocketAddress()"
    ></shiprocket-address-banner>
  </div>

  <!--  CTA container-->
  <div *ngIf="!loading" class="tw-flex-none tw-bottom-0 tw-left-0 tw-right-0 tw-bg-white" [class]="isfromReviewOrderAndDeliveryDateExists ? 'tw-p-6 tw-pb-0' : 'tw-p-6'">
    @if (!hideLocation) {
      @if (acqRebranding2025) {
        <button csButton="muted"
              id="useCurrentLocation"
              type="button"
              class="tw-w-full"
              [loading]="isLocatingAddress"
              [disabled]="!addressForm"
              (click)="getLocationDetails()"
              i18n="@@useMyCurrentLocation"
        >Use current location</button>
      } @else {
        <cs-button [class]="'tw-w-full tw-bg-white tw-border tw-border-gray-900 tw-rounded-[50px]'" *ngIf="!hideLocation" (callback)="getLocationDetails()" [disabled]="!addressForm" [loading]="isLocatingAddress">
          <cs-button-text class="tw-flex tw-justify-center">
            <span class=" tw-text-green-500" i18n="@@useMyCurrentLocation">Use current location</span>
          </cs-button-text>
        </cs-button>
      }
    }
    @if (showRebrandedUI) {
      @if (isReviewOrderDirectAdd) {
        <button csButton
              id="proceedToPay"
              type="button"
              class="tw-w-full"
              [loading]="inProcess || (saveInProcess$ | async) || (checkoutInProgress$ | async)"
              (click)="saveAddress()"
              i18n="@@proceedToPay"
        >Proceed to pay</button>
      } @else if (isEdit) {
        <button csButton
              id="saveAddress"
              type="button"
              class="tw-w-full"
              [loading]="inProcess || (saveInProcess$ | async) || (checkoutInProgress$ | async)"
              (click)="saveAddress()"
              i18n="@@save"
        >Save</button>
      } @else {
        <button csButton
              id="continueAddress"
              type="button"
              class="tw-w-full tw-bg-gray-400"
              [loading]="inProcess || (saveInProcess$ | async) || (checkoutInProgress$ | async)"
              (click)="saveAddress()"
              i18n="@@continue"
        >Continue</button>
      }
    } @else {
      <cs-button class="tw-mt-4" [class]="'tw-w-full primary tw-text-white disabled:bg-white'" (click)="saveAddress()" [disabled]="!addressForm" [loading]="inProcess || (saveInProcess$ | async) || (checkoutInProgress$ | async)">
        <cs-button-text *ngIf="isReviewOrderDirectAdd" i18n="@@proceedToPay">Proceed to pay</cs-button-text>
        <cs-button-text *ngIf="!isReviewOrderDirectAdd && !isEdit" i18n="@@continue">Continue</cs-button-text>
        <cs-button-text *ngIf="!isReviewOrderDirectAdd && isEdit" i18n="@@save">Save</cs-button-text>
      </cs-button>
    }
    @if (isfromReviewOrderAndDeliveryDateExists) {
      <div class="tw-mb-5">
        <app-expected-delivery-date
          *ngIf="!loading"
          [expectedDeliveryDate]="expectedDeliveryDate"
          [dayDifference]="dayDifference"
        />
      </div>
    }
  </div>
</div>
<!--popup ups-->
<pop-up *ngIf="popUpModal?.open" [class]="'tw-rounded-2.5 tw-p-4'" [show]="popUpModal?.open" [triggerDismiss]="true" (close)="closePopup()">
  <div>
    <div class="tw-mb-4 tw-font-bold tw-text-500" i18n="@@invalidPinTitle">Invalid Pincode</div>
    <div class="tw-mb-4 tw-text-400" i18n="@@invalidPincode">
      Pincode looks wrong, Do you want to autofill the correct pincode?
    </div>
    <div class="tw-flex tw-items-center tw-justify-end tw-flex-wrap">
      <div class="tw-w-1/2">
        <cs-button (click)="onClickYes()" [class]="'primary tw-w-full btn-xs'">
          <cs-button-text i18n="@@ok">Ok</cs-button-text>
        </cs-button>
      </div>
      <div class="tw-w-1/2">
        <cs-button (click)="closePopup()" [class]="'secondary only-text btn-xs tw-pl-0'">
          <cs-button-text i18n="@@no">No</cs-button-text>
        </cs-button>
      </div>
    </div>
  </div>
</pop-up>
